<template>
  <article class="row border-bottom">
    <div class="col d-flex flex-row align-items-center">
      <img
        class="card-img-left align-item-center rounded-circle"
        src="@/assets/avatar.jpg"
        style="width: 48px"
      />
      <div class="display-flex flex-column flex-grow-1 ms-2">
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam qui
          commodi ipsum maiores dolore dolores provident quaerat corporis
          blanditiis nulla!
        </p>
      </div>
      <div
        class="display-flex flex-column align-items-right align-self-flex-start"
      >
        <p class="mb-0 text-center text-muted">2s</p>
        <div class="dropdown">
          <button
            class="btn"
            type="button"
            id="dropdownMenuLink"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i class="fas fa-ellipsis-h"></i>
          </button>
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
            <li>
              <div class="dropdown-item">
                <i class="fas fa-trash me-2"></i>Sil
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
export default {};
</script>

<style></style>
